import { createSlice } from '@reduxjs/toolkit';

const supportTicketSlice = createSlice({
    name: 'supportTickets',
    initialState: {
        list: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 10,
            total: 0,
            totalPages: 1,
        },
        update: {
            loading: false,
            error: null,
            data: null,
        },
    },
    reducers: {
        fetchSupportTicketsStart: (state) => {
            state.list.loading = true;
            state.list.error = null;
        },
        fetchSupportTicketsSuccess: (state, action) => {
            state.list = { ...action.payload, loading: false };
        },
        fetchSupportTicketsFail: (state, action) => {
            state.list.loading = false;
            state.list.error = action.payload;
        },

        updateSupportTicketStart: (state) => {
            state.update.loading = true;
            state.update.error = null;
        },
        updateSupportTicketSuccess: (state, action) => {
            state.update.loading = false;
            state.update.data = action.payload;
        },
        updateSupportTicketFail: (state, action) => {
            state.update.loading = false;
            state.update.error = action.payload;
        },
    },
});

export const {
    fetchSupportTicketsStart,
    fetchSupportTicketsSuccess,
    fetchSupportTicketsFail,
    updateSupportTicketStart,
    updateSupportTicketSuccess,
    updateSupportTicketFail,
} = supportTicketSlice.actions;

export default supportTicketSlice.reducer;

